import { Outlet, useLocation } from "react-router";
import Header from "./header/Header";
import SideBar from "./sidebar/SideBar";
import { getApi } from "../services/api/globalApi";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleUtils } from "../sotre/redux/features/utilsSlice";

export default function Layout() {
  const dispatch = useDispatch();
  const location = useLocation();

  const getUtils = async () => {
    const path = "api/utils/constants";
    try {
      const response = await getApi({ path });
      dispatch(handleUtils(response.data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUtils();
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  return (
    <div className="flex justify-end">
      <SideBar />
      <div className="lg:w-9/12 duration-300 ease-linear mb-8 w-full overflow-x-hidden">
        <Header />
        <div className="px-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
